var contactPopupController;

(function(){
  
  $(document).ready(function(){
    initPopup();
  });
  
  function initPopup(){
    var iframe = $('<iframe frameborder="0" marginwidth="0" marginheight="0" allowfullscreen></iframe>');
    var closePopupBtn = $('<div class="close-popup">X</div>');
    dialog = $("<div></div>").append(iframe).append(closePopupBtn).appendTo("body").dialog({
      autoOpen: false,
      modal: true,
      classes: {
        "ui-dialog": "contact-dialog"
      },      
      resizable: false,
      width: "auto",
      height: "auto",
      open: function(){
        $('.ui-widget-overlay').addClass('contact-dialog-overlay');
        $('html').css('overflow','hidden');
      },
      close: function () {
        iframe.attr("src", "");
        $('html').css('overflow','visibile');
      }
    });

    $(".open-popup-contact").on("click", function (e) {
      e.preventDefault();
      var src = $(this).attr("data-href");
      var title = "Titolo";

      /*
      var title = $(this).attr("data-title");
      var width = $(this).attr("data-width");
      var height = $(this).attr("data-height");
      */
      
      var iframeWidth = Math.min(491,($(window).width()-9));
      
      iframe.attr({
        width: iframeWidth,
        height: 470,
        src: src
      });
      dialog.dialog("option", "title", title).dialog("open");
      
    });
    
    $(closePopupBtn).on("click", function(e){
      e.preventDefault();
      dialog.dialog("close");
    });
  }
  
}())